import React from "react";
import "../../scss/code_bars.scss";

export default function CodeBars() {
  return <div id="container"></div>;
}
